import { useMemo } from 'react';

export function useCheckForAvailableData(data, type) {
  const isAvailableData = useMemo(
    () => () => {
      if (type && data) {
        const target = data.filter(item => item.type === type);
        if (target.length === 0) return false;
        return !(target && !target[0].measurement);
      }
      return false;
    },
    [data, type],
  );

  return isAvailableData();
}



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/useCheckForAvailableData.js